export const storyHistoricalToHistoricalEmissionsData = (historicalEmissions: {
  [key: string]: number;
}): { [year: number]: number } => {
  return (
    Object.fromEntries(
      Object.entries(historicalEmissions ?? {})
        .map(([year, value]): [number, number] | undefined => (!!Number(year) ? [Number(year), value] : undefined))
        .filter((entry): entry is [number, number] => entry !== undefined)
    ) ?? {}
  );
};
